// extracted by mini-css-extract-plugin
module.exports = {"section":"style_section__1ItUs","title":"style_title__2tjlJ"};